import { useContext, useEffect } from 'react';
import { Store } from '../../Store';

/**
 * ThemeSync — keeps the `<html>` element's `dark` class in sync with the
 * Store's theme state. Mount this once near the root of the app (inside
 * StoreProvider but before any Tailwind-styled UI).
 *
 * NOTE: This applies dark mode globally to the whole document. The public
 * client side (Figma redesign) is unaffected because its components use the
 * fixed Figma palette (ink/surface/divider/brand/stepTint), which is NOT
 * defined via CSS variables — so its colors don't change with `.dark`.
 */
export default function ThemeSync({ children }) {
  const { state } = useContext(Store);
  const theme = state.theme;

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  return children ?? null;
}
